module.exports = __webpack_public_path__ + "img/header-pc-2.aa4b6450.png";